import React, { useEffect } from 'react'
import { Grid, Typography, Card, CardContent, Button } from '@mui/material'
import { useLocation, useHistory } from 'react-router-dom'
import { useDispatch, useSelector } from 'react-redux'
import { getBookedLessonByMoMoOrderId } from '../../actions/learningScheduleForStudent'
import Spinner from '../../components/ui/Spinner'
import moment from 'moment'
import formatMoney from '../../utils/formatMoney'
import convertMillisecondsToMinutes from '../../utils/convertMillisecondsToMinutes'
import displayBookedLessonEndingTimeForStudent from '../../utils/displayBookedLessonEndingTimeForStudent'

export const MoMoSuccessPage = () => {
  const search = useLocation().search
  const MoMoOrderId = new URLSearchParams(search).get('orderId')

  const { bookedLesson, loading } = useSelector(state => state.learningScheduleForStudent)
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(getBookedLessonByMoMoOrderId(MoMoOrderId))
  }, [dispatch, MoMoOrderId])

  const history = useHistory()

  const handleGoToLessonsManagement = () => {
    history.push("/students/lessons-manager")
  }

  if (loading || !bookedLesson) {
    return <Spinner />
  }

  return (
    <Grid
      container
      direction="column"
      justifyContent="center"
      alignItems="center"
      className="container"
      spacing={2}
      style={{ width: '100%', margin: '0' }}
    >
      <Grid item>
        <Typography variant="h4" component="h4">
          Bạn đã đặt bài học thành công!
        </Typography>
      </Grid>

      <Grid item>
        <Card>
          <CardContent>
            <Grid container direction="column">
              <Grid item>
                <Typography
                  variant="h5"
                  component="h5"
                  style={{ textAlign: 'center' }}
                >
                  Thông tin bài học:
                </Typography>
              </Grid>

              <Grid item>
                <Typography variant="body1">
                  <strong>Tên bài học:</strong>&nbsp;
                  {bookedLesson &&
                    bookedLesson.lesson &&
                    bookedLesson.lesson.lessonName}
                </Typography>
              </Grid>

              <Grid item>
                <Typography variant="body1">
                  <strong>Tên giáo viên:</strong>&nbsp;
                  {bookedLesson &&
                    bookedLesson.teacher &&
                    bookedLesson.teacher.name}
                </Typography>
              </Grid>

              <Grid item>
                <Typography variant="body1">
                  <strong>Skype ID:</strong>&nbsp;
                  {bookedLesson && bookedLesson.profileTeacher && bookedLesson.profileTeacher.skypeId && bookedLesson.profileTeacher.skypeId}
                </Typography>
              </Grid>

              <Grid item>
                <Typography variant="body1">
                  <strong>Số điện thoại:</strong>&nbsp;
                  {bookedLesson && bookedLesson.profileTeacher && bookedLesson.profileTeacher.phoneNumber && bookedLesson.profileTeacher.phoneNumber}
                </Typography>
              </Grid>

              <Grid item>
                <Typography variant="body1">
                  <strong>Giá tiền:</strong>&nbsp;
                  {bookedLesson && formatMoney(`${bookedLesson.price}`)}
                  &nbsp;VNĐ
                </Typography>
              </Grid>

              {bookedLesson && (
                <Grid item>
                  <Typography variant="body1">
                    <strong>Thời lượng:</strong>&nbsp;
                    {convertMillisecondsToMinutes(bookedLesson.duration)}
                    &nbsp;phút
                  </Typography>
                </Grid>
              )}

              {bookedLesson &&
                bookedLesson.bookedTime &&
                bookedLesson.bookedTime[0] && (
                  <Grid item>
                    <Typography variant="body1">
                      <strong>Thời gian bắt đầu:</strong>&nbsp;
                      {moment(bookedLesson.bookedTime[0].start).format(
                        'HH [giờ] mm [phút], [ngày] DD, MMMM, YYYY'
                      )}
                    </Typography>
                  </Grid>
                )}

              {bookedLesson &&
                bookedLesson.bookedTime &&
                bookedLesson.bookedTime[0] && bookedLesson.duration && (
                  <Grid item>
                    <Typography variant="body1">
                      <strong>Thời gian kết thúc:</strong>&nbsp;
                      {displayBookedLessonEndingTimeForStudent(bookedLesson)}
                    </Typography>
                  </Grid>
                )}

              <Grid item>
                <Typography variant="body1">
                  <strong>Lưu ý: </strong>Bạn vui lòng kết nối với giáo viên qua
                  skype và online đúng giờ học.
                </Typography>
              </Grid>

              <Grid item style={{ alignSelf: 'center' }}>
                <Button
                  onClick={handleGoToLessonsManagement}
                  variant="text"
                  disableRipple
                  style={{
                    fontSize: '1rem',
                    textTransform: 'none',
                    fontWeight: '600',
                    color: '#0066CC',
                    textDecoration: 'underline',
                  }}
                >
                  Đến trang quản lý các bài học.
                </Button>
              </Grid>
            </Grid>
          </CardContent>
        </Card>
      </Grid>
    </Grid>
  );
}
